
import { defineComponent } from 'vue'
import { MerchantListItem } from '@/types/core/merchant.type'
import Pagination from '@/components/shared/pagination/Pagination.vue'
import IPagination from '@/types/api/pagination.type'
import { __GetMerchantListPayload } from '@/stores/result/action-dto'
import VButton from '@/components/shared/button/VButton.vue'
import TSortDictionary from '@/types/api/sort-dictionary.type'
import { ExcelMerchantListType } from '@/types/api/export-excel.type'

export default defineComponent({
  name: 'MerchantListTable',
  components: {
    VButton,
    Pagination,
  },
  props: {
    campaignCode: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      sortBy: null as 'RegisterDate' | null,
      sortDictionary: null as TSortDictionary,
      pagination: {
        page: 1,
        length: 10,
      } as Pick<IPagination, 'page' | 'length'>,
      arrow_down: require("@/assets/svgs/icons/sort/arrow_down.svg"),
      arrow_up: require("@/assets/svgs/icons/sort/arrow_up.svg"),
      arrow_null: require("@/assets/svgs/icons/sort/arrow.svg"),
    }
  },
  async mounted() {
    await this.getMerchantList()
  },
  computed: {
    firstIndexInPage(): number {
      return (this.pagination.page - 1) * this.pagination.length
    },
    merchantList(): Array<MerchantListItem> {
      return this.$store.getters['merchantList']
    },
    isLoadingMerchantList(): boolean {
      return this.$store.getters['isLoadingMerchantList']
    },
    isErrorLoadingMerchantList(): boolean {
      return this.$store.getters['isErrorLoadingMerchantList']
    },
    isNoMerchantList(): string | null {
      return this.$store.getters['isNoMerchantList']
    },
    paginationMerchantList(): IPagination {
      return this.$store.getters['paginationMerchantList']
    },
    sortIcon() {
      if (this.sortBy === 'RegisterDate') {
        return this.sortDictionary === 'ASC' ? 'arrow_up' : 'arrow_down'
      }
      return 'arrow_null'
    },
  },
  watch: {
    campaignCode: {
      deep: true,
      handler: async function (newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
          await this.getMerchantList()
        }
      },
    },
    isLoadingMerchantList: {
      deep: true,
      handler: function (newVal: string) {
        if (!newVal && !this.isErrorLoadingMerchantList) {
          this.pagination = {
            page: this.paginationMerchantList.page,
            length: this.paginationMerchantList.length,
          }
        }
      },
    },
  },
  methods: {
    async getMerchantList() {
      if (!this.campaignCode) return
      try {
        const getMerchantListPayload: __GetMerchantListPayload = {
          campaignCode: this.campaignCode,
          sortBy: this.sortBy,
          sortDictionary: this.sortDictionary,
          pagination: this.pagination,
        }
        await this.$store.dispatch('getMerchantList', getMerchantListPayload)
      } catch (error) {
        console.error('Error fetching merchant list:', error)
        throw error
      }
    },
    formatDate(dateString: string): string {
      return this.$dayjs(dateString).format('YYYY/MM/DD HH:mm:ss')
    },
    handlePageChange(nextPage: number) {
      if (nextPage < 1) {
        this.pagination.page = 1
      } else if (nextPage > this.paginationMerchantList.totalPages) {
        this.pagination.page = this.paginationMerchantList.totalPages
      } else {
        this.pagination.page = nextPage
      }
      this.getMerchantList()
    },
    handleSelectPageNumber(pageNumber: number) {
      this.pagination.page = pageNumber
      this.getMerchantList()
    },
    handlePageLengthChange(pageLength: number) {
      this.pagination.length = pageLength
      this.pagination.page = 1
      this.getMerchantList()
    },
    async DoExportExcel() {
      const payload = {
        campaignCode: this.campaignCode,
        sortBy: this.sortBy,
        sortDictionary: this.sortDictionary,
        pagination: {
          length: 100000,
          page: 1,
        },
        excelMerchantListType: ExcelMerchantListType.AffiliateExperience,
      }
      await this.$store.dispatch('getExcelMerchantList', payload)
    },
    sort() {
      this.sortBy = 'RegisterDate'
      
      switch (this.sortDictionary) {
        case 'DESC':
          this.sortDictionary = 'ASC'
          break;
        case 'ASC':
          this.sortBy = null
          this.sortDictionary = null
          break;
        default:
          this.sortDictionary = 'DESC'
      }
      this.getMerchantList()
    },
  },
})
